export default "__VITE_ASSET__aec75a3d__"